import moment from 'moment';

export interface TimingSummaryItem {
  examStartTime?: string | null;
  estimatedExamEndTime?: string | null;
}

export interface TimingSummaryResult {
  startMinTimestamp: number | null;
  startMaxTimestamp: number | null;
  endMinTimestamp: number | null;
  endMaxTimestamp: number | null;
  startSummaryText: string | null;
  endSummaryText: string | null;
}

function getTimestamp(value?: string | null): number | null {
  if (!value) {
    return null;
  }

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}

function formatTimestamp(timestamp: number): string {
  return moment(timestamp).local().format('h:mm A [on] MMMM Do');
}

export function buildTimingSummary(items: TimingSummaryItem[]): TimingSummaryResult {
  let startMinTimestamp: number | null = null;
  let startMaxTimestamp: number | null = null;
  let endMinTimestamp: number | null = null;
  let endMaxTimestamp: number | null = null;

  items.forEach((item) => {
    const startTimestamp = getTimestamp(item.examStartTime);
    if (startTimestamp !== null) {
      startMinTimestamp = startMinTimestamp === null ? startTimestamp : Math.min(startMinTimestamp, startTimestamp);
      startMaxTimestamp = startMaxTimestamp === null ? startTimestamp : Math.max(startMaxTimestamp, startTimestamp);
    }

    const endTimestamp = getTimestamp(item.estimatedExamEndTime);
    if (endTimestamp !== null) {
      endMinTimestamp = endMinTimestamp === null ? endTimestamp : Math.min(endMinTimestamp, endTimestamp);
      endMaxTimestamp = endMaxTimestamp === null ? endTimestamp : Math.max(endMaxTimestamp, endTimestamp);
    }
  });

  const startSummaryText =
    startMinTimestamp !== null && startMaxTimestamp !== null
      ? `Students started between ${formatTimestamp(startMinTimestamp)} and ${formatTimestamp(startMaxTimestamp)}.`
      : null;

  const endSummaryText =
    endMinTimestamp !== null && endMaxTimestamp !== null
      ? `Students are expected to complete the exam between ${formatTimestamp(endMinTimestamp)} and ${formatTimestamp(
          endMaxTimestamp
        )}.`
      : null;

  return {
    startMinTimestamp,
    startMaxTimestamp,
    endMinTimestamp,
    endMaxTimestamp,
    startSummaryText,
    endSummaryText,
  };
}
